import React from "react";

import { Row, Col, Layout } from "antd";

import Footer from "../../components/Footer/Footer";
import ContactUsForm from "../../components/ContactUsForm/ContactUsForm";
import classes from "./ContactUs.css";
import withTrackerGA from "../../utils/withTrackerGA";
import logoDefault from "../../assets/img/diamind_logo.png";
import { getUserToken } from "../../reducers/user/selectors";
import { getTheme } from "../../reducers/theme/selectors";
import { login, loginTwoFactor } from "../../reducers/user/actions";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import classNames from "classnames";
import { Link } from "react-router-dom";

const { Content } = Layout;

const routes = require("../../routes.json");

class ContactUs extends React.Component {
  render() {
    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 16, offset: 4 }}
                style={{ paddingTop: "4rem" }}
              >
                <Row type="flex" justify="center">
                  <h2 className={classes.headline}>
                    <Link to={routes.admin.dashboard}>
                      <img
                        alt="diamond-trial-logo"
                        src={this.props.theme.logo_dark}
                        style={{
                          objectFit: "contain",
                          width: "160px",
                          height: "auto",
                          marginBottom: "10px",
                        }}
                      />
                    </Link>
                  </h2>
                  <ContactUsForm />
                </Row>
              </Col>
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  theme: getTheme(state),
});

const mapDispatchToProps = {
  login,
  loginTwoFactor,
};

export default withTrackerGA(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ContactUs))
);



// WEBPACK FOOTER //
// ./src/containers/ContactUs/ContactUs.js